var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { AbrechnungsbeauftragungState } from '../enums/abrechnungsbeauftragung-state.enum.js';
import { Paragraf18MitteilungDto } from './paragraf-18-mitteilung.dto.js';
/** A version of the terms as it is shown to the practice. */
export class AbrechnungsbeauftragungTermsDto {
    version;
    /** The contract text as HTML. */
    html;
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], AbrechnungsbeauftragungTermsDto.prototype, "version", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], AbrechnungsbeauftragungTermsDto.prototype, "html", void 0);
/**
 * An acceptance, as metadata.
 *
 * ⚠ **Without the IP.** The IP is stored (#1591) and belongs to the evidence,
 * not on the screen: it answers no question a practice asks about its own
 * Beauftragung, and every field in a response is a field that can be passed on
 * somewhere.
 */
export class AbrechnungsbeauftragungAcceptanceDto {
    /** This entry's address. The PDF copy hangs on it (#1614). */
    id;
    termsVersion;
    /** ISO 8601. */
    acceptedAt;
    acceptedByUserId;
    /** The name as it stood on the account at the moment of acceptance. */
    acceptedByName;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], AbrechnungsbeauftragungAcceptanceDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], AbrechnungsbeauftragungAcceptanceDto.prototype, "termsVersion", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], AbrechnungsbeauftragungAcceptanceDto.prototype, "acceptedAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], AbrechnungsbeauftragungAcceptanceDto.prototype, "acceptedByUserId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], AbrechnungsbeauftragungAcceptanceDto.prototype, "acceptedByName", void 0);
/** The record itself, once there is one. */
export class AbrechnungsbeauftragungRecordDto {
    id;
    /** Derived from the fields and today's Berlin calendar day. */
    state;
    /** First covered day, inclusive. `YYYY-MM-DD`. */
    effectiveFrom;
    /** Last covered day, inclusive, or `null`. Set by #1615. */
    endsOn;
    /** The highest accepted version. */
    currentTermsVersion;
    acceptances;
    /**
     * This Auftragsverhältnis's § 18 Mitteilungen, in the order they came into
     * being (TM-9636 / #1632).
     *
     * ⚠ **On this record and not on the Standort.** Every Beauftragung is an
     * Auftragsverhältnis of its own whose beginning and end the Kassen get to know
     * (`CONTEXT.md`, *Abrechnungsbeauftragung*). The previous one's sheets
     * described a different one.
     */
    mitteilungen;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], AbrechnungsbeauftragungRecordDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], AbrechnungsbeauftragungRecordDto.prototype, "state", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], AbrechnungsbeauftragungRecordDto.prototype, "effectiveFrom", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], AbrechnungsbeauftragungRecordDto.prototype, "endsOn", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], AbrechnungsbeauftragungRecordDto.prototype, "currentTermsVersion", void 0);
__decorate([
    Expose(),
    Type(() => AbrechnungsbeauftragungAcceptanceDto),
    __metadata("design:type", Array)
], AbrechnungsbeauftragungRecordDto.prototype, "acceptances", void 0);
__decorate([
    Expose(),
    Type(() => Paragraf18MitteilungDto),
    __metadata("design:type", Array)
], AbrechnungsbeauftragungRecordDto.prototype, "mitteilungen", void 0);
/**
 * Response of `GET /v1/office-locations/:officeLocationId/abrechnungsbeauftragung`
 * (#1613).
 *
 * ⚠ **The envelope always stands, the record is `null` as long as none
 * exists.** A practice without a Beauftragung still needs the offered contract
 * text, otherwise the foldout view would have nothing to show and would have to
 * fetch it from a second endpoint.
 */
export class AbrechnungsbeauftragungResponseDto {
    /** The version currently offered, with its text. */
    offeredTerms;
    /**
     * The covered IKs, **derived**: every Leistungserbringer IK of this Standort
     * with `participatesInGkvBilling`. An IK added later appears here without a
     * new acceptance.
     */
    coveredIks;
    record;
    /**
     * There is a version above the accepted one, and the Beauftragung is not
     * *ended*. `false` as long as no record exists — then nothing is "newer", it
     * is simply that nothing has been accepted yet.
     */
    newerTermsAvailable;
}
__decorate([
    Expose(),
    Type(() => AbrechnungsbeauftragungTermsDto),
    __metadata("design:type", AbrechnungsbeauftragungTermsDto)
], AbrechnungsbeauftragungResponseDto.prototype, "offeredTerms", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], AbrechnungsbeauftragungResponseDto.prototype, "coveredIks", void 0);
__decorate([
    Expose(),
    Type(() => AbrechnungsbeauftragungRecordDto),
    __metadata("design:type", Object)
], AbrechnungsbeauftragungResponseDto.prototype, "record", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], AbrechnungsbeauftragungResponseDto.prototype, "newerTermsAvailable", void 0);
//# sourceMappingURL=abrechnungsbeauftragung.response.dto.js.map